import {
  posterBookingBroadcastChannelName,
  PosterBookingOAuthEvent,
} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-posterbooking-panel/publishing-posterbooking-panel.types';

export const addPosterBookingOAuthBroadcastChannel = (onSuccess: VoidFunction, onError: VoidFunction): BroadcastChannel | undefined => {
  const broadcastChannel = new BroadcastChannel(posterBookingBroadcastChannelName);
  broadcastChannel.addEventListener('message', (ev: MessageEvent<PosterBookingOAuthEvent>) => {
    console.log(ev);
    if (ev.data === PosterBookingOAuthEvent.SUCCESS) {
      onSuccess();
    } else {
      onError();
    }
  });

  return broadcastChannel;
};

export const removePosterBookingOAuthBroadcastChannel = (posterBookingOAuthBroadcastChannel?: BroadcastChannel): void => {
  if (!posterBookingOAuthBroadcastChannel) {
    return;
  }

  posterBookingOAuthBroadcastChannel.close();
};
